import { imageFile } from 'common/helpers/miscHelper';

const ProductImageThumbnail = (props) => {
  const { onClick, image, alt } = props;
  const handleClick = (e) => {
    e.preventDefault();
    onClick(image.src);
  };

  return (
    <a key={image.id} onClick={handleClick}>
      <img src={imageFile(image.src, 'small')} alt={alt} loading="lazy" />
    </a>
  );
};

export default ProductImageThumbnail;
